import React from 'react'

function StepDiv(props) {
    return (
        <div className='stepDiv'>
            <h1 className="heading1">
                {props.stepNumber}. {props.stepTitle}
            </h1>

            {/* Form */}
            <p className='formHeader'>
                {props.stepDescription}
            </p>
        </div>
    );
}

export default StepDiv